import { render, staticRenderFns } from "./PopupDecline.vue?vue&type=template&id=6a864c0c&scoped=true&lang=pug"
import script from "./PopupDecline.vue?vue&type=script&lang=ts"
export * from "./PopupDecline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a864c0c",
  null
  
)

export default component.exports